import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Home
import { HomeComponent } from './modules/home/home.component';

// Policies
import { PoliciesOverviewComponent } from '@modules/policies/policy-overview/policies-overview.component';
import { PolicyDetailComponent } from '@modules/policies/policy-detail/policy-detail.component';
import { InsuredTripsComponent } from '@modules/policies/policy-detail/policy-detail-legal-person/insured-trips/insured-trips.component';

// Claims
import { ClaimsComponent } from '@modules/claims/claims.component';
import { NewClaimComponent } from '@modules/claims/new-claim/new-claim.component';

// Contact us
import { ContactUsComponent } from '@modules/contact-us/contact-us.component';
import { EmailUsComponent } from '@modules/inbox/email-us/email-us.component';
import { InboxComponent } from '@modules/inbox/inbox.component';

// Other
import { NotFoundComponent } from '@modules/not-found/not-found.component';
import { UserRole } from '@shared/models/codebooks/user-role';

// Service
import { AuthGuard } from '@core/services/auth.guard';
import { MaintenanceComponent } from '@modules/maintenance/maintenance.component';
import { NewInsuredTripComponent } from '@modules/policies/policy-detail/policy-detail-legal-person/insured-trips/new-insured-trip/new-insured-trip.component';
import { EditInsuredTripComponent } from '@modules/policies/policy-detail/policy-detail-legal-person/insured-trips/edit-insured-trip/edit-insured-trip.component';
import { EmployeesComponent } from '@modules/policies/policy-detail/policy-detail-legal-person/employees/employees.component';
import { CancelPolicyComponent } from '@modules/policies/policy-detail/policy-detail-individual/cancel-policy/cancel-policy.component';
import { AgentSource } from '@shared/models/codebooks/agent-source';
import { ProfileComponent } from '@modules/profile/profile.component';
import { ProfileEditComponent } from '@modules/profile/profile-edit/profile-edit.component';


const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            textToTranslate: "topbar.menu.home",
            active: false,
            enabled: true,
            roles: [UserRole.Individual, UserRole.LegalPerson, UserRole.B2BLease]
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'moj-profil',
        data: {
            active: false,
            enabled: true,
            roles: [UserRole.Individual, UserRole.LegalPerson]
        },
        children: [
            {
                path: '',
                component: ProfileComponent,
            },
            {
                path: 'editacia',
                component: ProfileEditComponent

            }
        ],
        canActivate: [AuthGuard]
    },
    {
        path: 'moje-poistky',
        data: {
            textToTranslate: "topbar.menu.my-policies",
            active: false,
            enabled: true,
            roles: [UserRole.Individual, UserRole.LegalPerson, UserRole.B2BLease]
        },
        children: [
            {
                path: '',
                component: PoliciesOverviewComponent
            },
            {
                path: ':status/:policyNumber',
                children: [
                    {
                        path: '',
                        component: PolicyDetailComponent,
                    },
                    {
                        path: 'poistene-cesty',
                        children: [
                            {
                                path: '',
                                component: InsuredTripsComponent,
                                data: {
                                    roles: [UserRole.LegalPerson]
                                }
                            },
                            // must be this order
                            {
                                path: 'nova-cesta',
                                component: NewInsuredTripComponent,
                                data: {
                                    roles: [UserRole.LegalPerson]
                                }
                            },
                            {
                                path: ':policyNumberTravelMember',
                                component: EditInsuredTripComponent,
                                data: {
                                    roles: [UserRole.LegalPerson]
                                }
                            }
                            // END must be this order

                        ]
                    },
                    {
                        path: 'zamestnanci',
                        children: [
                            {
                                path: '',
                                component: EmployeesComponent,
                                data: {
                                    roles: [UserRole.LegalPerson]
                                }
                            }
                        ]
                    },
                    {
                        path: 'storno',
                        children: [
                            {
                                path: '',
                                component: CancelPolicyComponent,
                                data: {
                                    roles: [UserRole.Individual],
                                    agentSource: [AgentSource.LEVEL2]
                                }
                            }
                        ]
                    }
                ]
            }
        ],
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard]
    },
    {
        path: 'moje-hlasenia',
        component: ClaimsComponent,
        data: {
            textToTranslate: "topbar.menu.my-claims",
            active: false,
            enabled: true,
            roles: [UserRole.Individual]
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'nove-hlasenie',
        component: NewClaimComponent,
        data: {
            textToTranslate: "topbar.menu.my-claims",
            active: false,
            enabled: false,
            roles: [UserRole.Individual]
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'kontaktujte-nas',
        component: ContactUsComponent,
        data: {
            textToTranslate: "topbar.menu.contact-us",
            active: false,
            enabled: true,
            roles: [UserRole.Individual]
        },
        canActivate: [AuthGuard]
    },
    {
        path: 'inbox',
        data: {
            activatePath: 'kontaktujte-nas',
            enabled: false,
            roles: [UserRole.Individual]
        },
        children: [
            {
                path: '',
                component: InboxComponent,
                data: {
                    roles: [UserRole.Individual]
                },
            },
            {
                path: 'napiste-nam',
                component: EmailUsComponent,
                data: {
                    roles: [UserRole.Individual]
                },
            }
        ],
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard]
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent,
        data: {
            enabled: true
        }
    },
    {
        path: '404',
        component: NotFoundComponent,
        data: {
            enabled: true
        }
    },
    { // must be last
        path: '**',
        redirectTo: '/404',
        data: {
            enabled: true
        }
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', enableTracing: false })],
    exports: [RouterModule]
})
export class AppRoutingModule { }
